import { Checkbox, Menu } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { HoldingsType } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Holdings/useHoldingsController';
import React from 'react';
import { CapMenu } from '@dealstack/frontend/app/pages/Project/Cap/CapTablePage/common/CapMenu.tsx';

interface Props {
	showSummarized: boolean;
	onSummarizedChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	showPercentages: boolean;
	onShowPercentagesChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	tableType: HoldingsType;
}

export const HoldingsTableSettings = ({
	showSummarized,
	onSummarizedChange,
	showPercentages,
	onShowPercentagesChange,
}: Props) => {
	const tCapManage = useTranslationCapManage();

	return (
		<CapMenu buttonTargetIcon={<Icon variant="more-v3" size="vlg" />}>
			<Menu.Label
				p="0.5rem"
				fw={400}
				sx={(theme) => ({
					fontSize: '14px',
					color: theme.colors.gray[9],
				})}
			>
				Customise View
			</Menu.Label>

			<Menu.Item p="0.5rem" closeMenuOnClick={false}>
				<Checkbox
					label={tCapManage('header_actions.summarise')}
					checked={showSummarized}
					onChange={onSummarizedChange}
				/>
			</Menu.Item>

			<Menu.Item p="0.5rem" closeMenuOnClick={false}>
				<Checkbox
					label={tCapManage('header_actions.show_percentages')}
					checked={showPercentages}
					onChange={onShowPercentagesChange}
				/>
			</Menu.Item>
		</CapMenu>
	);
};
